import { Component } from '@mycolorway/tao';
import Dialog from 'next/javascripts/components/dialog';
import editorFormMixin from 'next/javascripts/mixins/editor-form-mixin';
import editorDraftMixin from 'next/javascripts/mixins/editor-draft-mixin';
import 'next/stylesheets/components/project/todo-desc-edit-dialog.scss';

Component('tr-todo-desc-edit-dialog', {
  extends: [Dialog],

  mixins: [editorFormMixin, editorDraftMixin],

  ready() {
    this.listenTo(this, 'tao:opened', () => {
      const editor = this.querySelector('tr-editor[lazyload]');
      if (editor) editor.initEditor();
    });
  },
});
